export interface FindAllDocumentsResponseDTO {
    total: number
    page: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number
    data: DocumentDTO[]
}

export interface DocumentDTO {
    id: number
    userId: string
    fileName: string
    type: DocumentType
    typology: DocumentTypology
    date: Date
    referenceYear: number
    referenceMonth: number
    referenceDate: Date
    note: string
    companiesDownloadDate: Date | null
    operatorsDownloadDate: Date | null
    senderGroup: 'operators' | 'companies' | 'admin' | ''
    receiverGroup: 'operators' | 'companies' | ''
    companyId: number
    eventId: number
    objectId: number
    status: DocumentStatus
    f24Status: DocumentF24Status
    f24PostponedFlag?: boolean
    f24PostponedReference?: number
    f24PostponedReferenceFilename?: string
}

export interface DocumentFilters {
    companyId?: number | null
    itemsPerPage: number
    order: boolean
    page: number
    receiverGroup: 'operators' | 'companies' | ''
    referenceYear: number
    referenceMonth: number
    senderGroup: 'operators' | 'companies' | 'admin' | ''
    sort: string
    type: DocumentType | ""
    typology: DocumentTypology | string
    fileName: string
    status: DocumentStatus | string
    f24Status: DocumentF24Status | string
}

export interface DocumentCreationDTO {
    fileName: string
    type: DocumentType
    typology: DocumentTypology
    date: string
    referenceYear: number
    referenceMonth: number
    referenceDate: string
    note: string
    senderGroup: 'operators' | 'companies' | 'admin'
    receiverGroup: 'operators' | 'companies'
    companyId: number
    f24PostponedFlag?: boolean
    f24PostponedReference?: number
}

export interface DocumentReportDTO {
    accounting: DocumentReportType
    balance: DocumentReportType
    f24: DocumentReportType
    employees: DocumentReportType
    other: DocumentReportType
}

export interface DocumentReportType {
    unreads: number
    totals: number
}

export interface FindExtensionsFileRequestDTO {
    ids: string[]
}

export interface FindExtensionsFileResponseDTO {
    extensions: string[]
}

export enum DocumentType {
    accounting = 'accounting',
    balance = 'balance',
    f24 = 'f24',
    employees = 'employees',
    other = 'other'
}

export enum DocumentStatus {
    toRead = "toRead",
    read = "read"
}

export enum DocumentTypology {
    unique = 'unique',
    iva = 'iva',
    document770 = 'document770',
    balanceDocument = 'balanceDocument',
    inspection = 'inspection',
    durc = 'durc',
    other = 'other',
    contributions = 'contributions',
    directTax = 'directTax',
    paySlip = 'paySlip',
    cu = 'cu',
    attendance = 'attendance',
    bankStatement = 'bankStatement',
    invoice = 'invoice',
    receipt = 'receipt',
    insurance = 'insurance',
    loan = 'loan',
    paypal = 'paypal'
}

export const DocumentTypologyMap = new Map<DocumentTypology, string>([
    [DocumentTypology.attendance, 'Presenze'],
    [DocumentTypology.balanceDocument, 'Bilanci'],
    [DocumentTypology.contributions, 'Contributi'],
    [DocumentTypology.cu, 'CU'],
    [DocumentTypology.directTax, 'Imposte dirette'],
    [DocumentTypology.document770, '770'],
    [DocumentTypology.durc, 'Durc'],
    [DocumentTypology.inspection, 'Visura'],
    [DocumentTypology.iva, 'IVA'],
    [DocumentTypology.other, 'Altro'],
    [DocumentTypology.paySlip, 'Busta paga'],
    [DocumentTypology.unique, 'Unico'],
    [DocumentTypology.bankStatement, 'Estratti conto'],
    [DocumentTypology.invoice, 'Fatture'],
    [DocumentTypology.receipt, 'Ricevute'],
    [DocumentTypology.loan, 'Finanziamenti'],
    [DocumentTypology.insurance, 'Assicurazioni'],
    [DocumentTypology.paypal, 'Paypal, Stripe, ecc']
])

export const DocumentStatusMap = new Map<DocumentStatus, string>([
    [DocumentStatus.read, 'Letto'],
    [DocumentStatus.toRead, 'Da leggere'],
])

export interface DocumentF24StatusUpdateDTO {
    f24Status: DocumentF24Status
    updateDate?: string
}

export enum DocumentF24Status {
    Idle = "Idle",
    Postponed = "Postponed",
    Pay = "Pay",
    Delay = "Delay"
}

export const statusF24Map = new Map<DocumentF24Status, string>([
    [DocumentF24Status.Idle, 'In attesa'],
    [DocumentF24Status.Postponed, 'Posticipato'],
    [DocumentF24Status.Pay, 'Pagato'],
    [DocumentF24Status.Delay, 'Richiesta di posticipo'],
])